module.exports = "/assets/site/images/promo-incentive.a9307d3e.png?a9307d3e";